<template>
  <div>
    <div class="g lookup-box-grid" v-if="showResults">
        <result-item v-for="result in results" :key="result.itemID" :result="result" />        
    </div>
    <div class="g lookup-box-grid" v-if="loading">
        <spinner :loading="loading" />
    </div>
    <div class="g lookup-box-grid" v-if="shouldDisplayMessage()">
      <div class="g__c g__c--12">
					<h2 class="text-center">{{ message }}</h2>
			</div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import Spinner from './Spinner.vue';
import ResultItem from './ResultItem.vue';

export default {
  components: {
    ResultItem,
    Spinner
  },
  computed: {
      ...mapState(['loading', 'showResults' , 'isInitialLoad', 'showError'])
    },
  props: {
    results: Array,
    message: String
  },
  methods: {
    shouldDisplayMessage() {
      return this.showError;
    }
  }
};
</script>